module.exports = __webpack_public_path__ + "img/viesa.ebad81f2.jpg";